import { useMemo } from 'react';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef } from '@mui/x-data-grid-pro';
import { generateGlobalColumns, generateDateColumn, IDataGridConfig, IAction } from '@ts/storybook';
import { useNavigate } from 'react-router';
import { KPI_EXECUTIONS_URL } from './constants';
import { IConfigComponent, CKPIExecution } from '@ts/ui-models';

interface IKPIExecutionsProps {
  kpiDefinitionId: string;
  configComponent?: IConfigComponent;
  inheritedProps?: any;
}

export const defaultConfigComponent = (kpiDefinitionId: string): IConfigComponent => {
  return {
    componentId: 'kpiDefinitions',
    aclId: 'KpiDef',
    fetchURL: KPI_EXECUTIONS_URL(kpiDefinitionId),
    //crudURL: 'tests',
    mainClass: CKPIExecution,
  };
};

const KPIExecutions = (props: IKPIExecutionsProps) => {
  const navigate = useNavigate();
  const { configComponent = defaultConfigComponent(props.kpiDefinitionId) } = props;
  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false, event: false },
  };

  const extraAction = (): IAction => {
    return {
      id: 'viewExecution',
      label: 'KPI Results',
      icon: 'manage_search',
      onClick: handleClick => {
        navigate(`/kpiExecutionResults/${props.kpiDefinitionId}/${handleClick().id}`);
      },
    };
  };

  const getColumns = useMemo((): GridColDef<any>[] => {
    const mixProps = { ...props, configComponent };
    const globalCells = generateGlobalColumns(mixProps);
    return [
      globalCells.id(),
      globalCells.name(),
      generateDateColumn({ field: 'timestamp', headerName: 'Executed At' }, { field: 'timestamp' }),
    ];
  }, [props, configComponent]);

  return (
    <WrapperDataGrid
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns}
      //Extra data
      withoutDefaultActions
      extraActions={[extraAction()]}
      inheritedProps={props.inheritedProps}
    />
  );
};

export default KPIExecutions;
